import { ChangeEvent, ReactElement, useEffect, useState } from 'react';
import { ColorRing } from 'src/components/shared/loader';
import { InputText } from 'primereact/inputtext';
import { useDebounce } from 'use-debounce';
import { v4 as uuidV4 } from 'uuid';
import classNames from 'classnames';
import './module.scss';

export type DebouncedSearchProps = {
    id?: string;
    name?: string;
    label?: string;
    placeholder?: string;
    autoFocus?: boolean;
    debounce?: number;
    value?: string;
    onSearch?: (value: string) => void;
    maxLength?: number;
    isDisabled?: boolean;
    isLoading?: boolean;
};

export const DebouncedSearch = (props: DebouncedSearchProps): ReactElement => {
    const {
        id = uuidV4(),
        autoFocus = false,
        name = id,
        debounce = 0,
        maxLength = 50,
        isLoading = false,
        isDisabled = false,
        value = '',
    } = props;

    const [headlessValue, setHeadlessValue] = useState(value);
    const [debounced, { flush }] = useDebounce(headlessValue, debounce);

    useEffect(() => {
        if (props.onSearch) props.onSearch(debounced);
    }, [debounced]);

    useEffect(() => {
        setHeadlessValue(value);
        flush();
    }, [props.value]);

    return (
        <div className={classNames('debounced-search')}>
            {props.label && (
                <label
                    className={classNames('debounced-search-label')}
                    htmlFor={id}
                >
                    {props.label}
                </label>
            )}

            <div className={'debounced-search-input-wrapper'}>
                <InputText
                    id={id}
                    value={headlessValue}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        setHeadlessValue(e.target.value)
                    }
                    name={name.toString()}
                    autoFocus={autoFocus}
                    placeholder={props.placeholder}
                    className={classNames('debounced-search-input')}
                    maxLength={maxLength}
                    disabled={isDisabled}
                />
                <ColorRing
                    wrapperClass={'search-loading'}
                    height={'20px'}
                    width={'20px'}
                    color={'#b5bdc2'}
                    visible={isLoading}
                    strokeWidth={7}
                />
            </div>
        </div>
    );
};
